import React, { useState } from "react";
import "./style.scss";
import CreateSet from "../../../components/Guidelines/CreateSet";

const UpdateSetPage = () => {
  return (
    <div className="updateset_page_wrapper">
      {/* <UpdateSet /> */}
      <CreateSet update={true} />
    </div>
  );
};
export default UpdateSetPage;
